import React from "react";
import { useHistory } from "react-router-dom";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";
import {
  PAYEES_ROOT_PATH,
  useGoToPayeeDetailsRequirements
} from "../../../utils";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { IPayeeResponse } from "@wingspanhq/payments/dist/interfaces";
import { getPayeeNames } from "../../../selectors/getPayeeNames";

type RequirementsDetailsProps = {
  payee: IPayeeResponse;
  requirement: IRequirementResponse;
};

export const RequirementsDetailsRoute: React.FC<RequirementsDetailsProps> = ({
  payee,
  requirement
}) => {
  const history = useHistory();
  const goToPayeeDetailsRequirements = useGoToPayeeDetailsRequirements();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payee
  });

  const names = getPayeeNames(payee);

  const title = requirementConfig.getRequirementName(requirement);

  return (
    <>
      <WSPageToolbar
        actions={requirementConfig.getToolbarActions(requirement)}
        breadcrumbs={[
          {
            label: "Contractors",
            onClick: () => {
              history.push(PAYEES_ROOT_PATH);
            }
          },
          {
            label: names.getResolvedName(),
            onClick: () => {
              goToPayeeDetailsRequirements(payee.payeeId);
            }
          },
          {
            label: title || "Requirement"
          }
        ]}
      />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payee}
        requirement={requirement}
      />
    </>
  );
};
